import React, { useCallback } from 'react';
import { useVisualizacao } from '../../VisualizacaoContext';
import { useTableViewManager } from '~/context/tableViewManager';

import { Loading } from '../Loading';
import { Container, ListContainer, ListItem } from './styles';
import { OptionsViewProps } from '../../types';

type Item = {
  label: string;
  value: number;
  qtd_colunas_fixadas: number;
  qtd_registro: number;
};

const SelectVisualizacao: React.FC = () => {
  const {
    setIsOpenModal,
    optionsViews,
    loadingViews,
    applyingVisualization,
    handleViewSelect,
    viewSelect,
    hadleViewRefetch,
    setLimit,
    setSelectedOptionView,
    setIsOpenPopup,
    getFields,
    optionSelected,
  } = useVisualizacao();

  const { onChangeCodCardSelected, onChangeViewSelected } =
    useTableViewManager();

  function corrigirArray(arr: any[]): Item[] {
    return arr
      .filter((item): item is Item => {
        return (
          item !== null &&
          typeof item === 'object' &&
          'value' in item &&
          'label' in item
        );
      })
      .map((item) => (item.value === -1 ? { ...item, label: 'PADRÃO' } : item))
      .reduce<Item[]>((acc, item) => {
        const exists = acc.some(
          (existing) =>
            existing.label === item.label &&
            existing.value === item.value &&
            existing.qtd_colunas_fixadas === item.qtd_colunas_fixadas &&
            existing.qtd_registro === item.qtd_registro,
        );
        return exists ? acc : [...acc, item];
      }, []);
  }

  const handleSelect = useCallback(
    (item) => {
      handleViewSelect(item);
      setLimit(item?.qtd_registro ?? 0);
      applyingVisualization(item?.value ?? -1);
      onChangeCodCardSelected(null);
      onChangeViewSelected(null);

      setTimeout(() => {
        if (Number(viewSelect?.value) === Number(item?.value)) return;
        hadleViewRefetch();
      }, 400);
    },
    [
      applyingVisualization,
      hadleViewRefetch,
      handleViewSelect,
      onChangeCodCardSelected,
      onChangeViewSelected,
      setLimit,
      viewSelect,
    ],
  );

  const padrao = optionsViews.find(
    (item) => item?.label?.toUpperCase() === 'PADRÃO',
  );
  const outrosOrdenados = optionsViews
    .filter((item) => item?.label?.toUpperCase() !== 'PADRÃO')
    .sort((a, b) => a.label.localeCompare(b.label));
  const resultadoFinal = [padrao, ...outrosOrdenados] as OptionsViewProps[];

  return (
    <Container>
      {loadingViews ? (
        <Loading />
      ) : (
        <ListContainer>
          {corrigirArray(resultadoFinal).map((item) => (
            <ListItem
              key={item?.value}
              className={item?.value === -1 ? 'padrao' : 'demais'}
              onClick={() => {
                handleSelect(item);
                setIsOpenPopup(false);
              }}
              style={{
                background:
                  Number(viewSelect?.value) === Number(item?.value)
                    ? '#f0f0f0'
                    : 'white',
              }}
            >
              {item?.label}
            </ListItem>
          ))}

          <ListItem
            className="customizar"
            onClick={async () => {
              if (viewSelect.value === -1) {
                setSelectedOptionView(null);
              } else {
                setSelectedOptionView({
                  label: viewSelect.label,
                  value: viewSelect.value,
                  qtd_colunas_fixadas: viewSelect.qtd_colunas_fixadas,
                  qtd_registro: viewSelect.qtd_registro,
                });

                if (optionSelected.length === 0)
                  await getFields(Number(viewSelect.value));
              }
              setIsOpenModal(true);
              setIsOpenPopup(false);
            }}
          >
            Customizar
          </ListItem>
        </ListContainer>
      )}
    </Container>
  );
};

export default SelectVisualizacao;
